class S19PurchaseSummary extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.section = this.closest('.shopify-section');
    this.price = Number(this.dataset.price);
    this.title = this.dataset.variantTitle;
    const options = {signal: this.controller.signal};
    this.section?.addEventListener('variant:update', event => {
      if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
      const variant = event.detail.resource;
      this.price = variant ? Number(variant.price) : NaN;
      this.title = variant?.title || 'Bu seçenek mevcut değil';
      this.update();
    }, options);
    this.section?.addEventListener('quantity-selector:update', () => this.update(), options);
    this.section?.addEventListener('change', event => {
      if (event.target.matches('input[name="quantity"]')) this.update();
    }, options);
    this.section?.addEventListener('input', event => {
      if (event.target.matches('input[name="quantity"]')) this.update();
    }, options);
    this.update();
  }
  disconnectedCallback() { this.controller?.abort(); }
  update() {
    const quantity = Number(this.section?.querySelector('product-form-component input[name="quantity"]')?.value || 1);
    const valid = Number.isFinite(this.price) && Number.isInteger(quantity) && quantity > 0;
    const selection = this.querySelector('[data-selection]');
    if (selection) selection.textContent = this.title;
    const details = this.querySelector('.s19-order-cost');
    if (!details) return;
    details.hidden = !valid;
    if (!valid) return;
    const subtotal = this.price * quantity;
    const shipping = subtotal > 200000 ? 0 : 12000;
    const format = cents => new Intl.NumberFormat('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2}).format(cents / 100) + ' TL';
    const set = (selector, text) => { const node = this.querySelector(selector); if (node) node.textContent = text; };
    set('[data-context]', `Bu üründen ${quantity} adet için`);
    set('[data-subtotal]', format(subtotal));
    set('[data-shipping]', shipping ? format(shipping) : 'Ücretsiz');
    set('[data-card-total]', format(subtotal + shipping));
    set('[data-cod-total]', format(subtotal + shipping + 6000));
  }
}
if (!customElements.get('s19-purchase-summary')) customElements.define('s19-purchase-summary', S19PurchaseSummary);
